var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsergroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 25 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5653_1565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6906 9.525C11.3208 9.525 13.4531 7.39271 13.4531 4.7625C13.4531 2.13229 11.3208 0 8.6906 0C6.06039 0 3.9281 2.13229 3.9281 4.7625V4.76354C3.9307 7.39271 6.06143 9.52292 8.6906 9.525Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9208 13.4594C11.5688 10.0208 6.06354 9.95103 2.625 13.3031C0.947396 14.9385 0.00104167 17.1823 0 19.525C0 19.9854 0.372917 20.3583 0.833333 20.3583H16.55C17.0104 20.3583 17.3833 19.9854 17.3833 19.525C17.3865 18.6411 17.25 17.7625 16.9792 16.9219C16.5755 15.6213 15.8703 14.4349 14.9208 13.4594Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 9.94167C20.706 9.94167 22.2916 8.35601 22.2916 6.4C22.2916 4.444 20.706 2.85834 18.75 2.85834C16.794 2.85834 15.2083 4.444 15.2083 6.4C15.2083 8.35601 16.794 9.94167 18.75 9.94167Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 10.9167C17.6328 10.9209 16.5375 11.225 15.5781 11.7974C15.7589 11.9589 15.9417 12.1182 16.1125 12.2932C17.2474 13.4594 18.0901 14.8776 18.5724 16.4318C18.7375 16.9432 18.8594 17.4682 18.9365 18H24.1667C24.6271 18 25 17.6271 25 17.1667C24.9964 13.7167 22.2 10.9203 18.75 10.9167Z",
    fill: "#484888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5653_1565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 20.3583,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsergroup);
export default __webpack_public_path__ + "static/media/usergroup.ba507df57a1fc77658fb18471ee6b7c8.svg";
export { ForwardRef as ReactComponent };